export function stopPropagation(e) {
    e.stopPropagation();
    e.preventDefault();
}

export function isSafari() {
    return ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)));
}

export function isWeiXin() { //it is wechat?
    var ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
}

export function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var result = window.location.search.substr(1).match(reg);
    if (!result) {
        var i = window.location.hash.indexOf('?');
        if (i != -1) {
            result = window.location.hash.substr(i + 1).match(reg);
        }
    }

    if (result != null) {
        return result[2];
    }
    return null;
}
